export default __webpack_public_path__ + "static/media/spring-boot.c257b61a.svg";